<template>
  <Slider :classes="sliderClasses">
    <template v-if="loaded">
      <Card
        v-for="(obituary, index) of data.obituaries"
        :key="`${obituary.id}-${index}`"
        :post="obituary"
      />
    </template>
    <template v-else>
      <CardSkeleton v-for="i in 3" :key="i" />
    </template>
  </Slider>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Slider from 'Components/Slider.vue';
import Card from 'Components/ObituaryCard/index.vue';
import CardSkeleton from 'Components/ObituaryCardSkeleton.vue';
import { safeGetItem } from 'Utils/safeLocalStorage';

export default {
  name: 'MemorialPagesSection',

  components: {
    Card,
    CardSkeleton,
    Slider,
  },

  data() {
    const { city, autoPopulateCity, slimTemplate } = this.$mountEl.dataset;

    return {
      autoPopulateCity,
      city,
      slimTemplate,
    };
  },

  computed: {
    ...mapState('obituaries', ['data', 'isLoading', 'loaded']),

    cityTerm() {
      const cityTerm = JSON.parse(safeGetItem('cityTerm'));
      return this.autoPopulateCity && cityTerm ? cityTerm : null;
    },

    filters() {
      let location = this.city ? this.city : null;

      if (this.cityTerm) {
        location = this.cityTerm.id;
      }

      return {
        location,
        take: 3,
      };
    },

    sliderClasses() {
      return !this.slimTemplate ? 'size-3' : 'size-2';
    },
  },

  mounted() {
    this.getObituaries(this.filters);
  },

  methods: {
    ...mapActions({
      getObituaries: 'obituaries/getObituaries',
    }),
  },
};
</script>
